import { BooleanInput } from '@angular/cdk/coercion';
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  inject,
  input,
  viewChild,
  ElementRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { ClipboardService } from '../../services/clipboard.service';
import { FormModeService } from '../../services/form-mode.service';
import { CopyButton } from '../copy-button/copy-button.component';
import { InputText } from '../input-text/input-text.component';

@Component({
  selector: 'procure-page-header-title',
  templateUrl: './page-header-title.component.html',
  styleUrl: './page-header-title.component.scss',
  imports: [InputText, MatTooltip, CopyButton],
  host: {
    '[attr.title]': '""',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderTitle {
  readonly tooltip = input<string>();
  readonly control = input<FormControl>();
  readonly title = input<string>();
  readonly fallbackTitle = input<string>();
  readonly revision = input<string>();
  readonly label = input<string>('Name');

  readonly isTitleEditable = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });

  readonly autofocus = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly titleValue = computed(
    () => this.title() || this.fallbackTitle(),
  );

  protected readonly formModeService = inject(FormModeService);

  private readonly clipboardService = inject(ClipboardService);
  private readonly inputElement =
    viewChild<ElementRef<HTMLElement>>('inputElement');

  constructor() {
    afterNextRender(() => {
      if (
        this.autofocus() &&
        !this.formModeService.isShowMode() &&
        this.isTitleEditable()
      ) {
        const inputEl =
          this.inputElement()?.nativeElement?.querySelector<HTMLInputElement>(
            'input',
          );
        inputEl?.focus();
      }
    });
  }

  protected copy(): void {
    this.clipboardService.copy(
      this.control()?.value || this.title() || this.fallbackTitle(),
    );
  }
}
